import {useWordPressPosts} from "../hook/wordpress/posts.wordpress.hook";
import {useMe} from "../hook/partner/authentication/me.partner.hook";
import {useAuthStore} from "../store/auth.store";
import {useLogin} from "../hook/partner/authentication/login.partner.hook";
import {useEffect, useState} from "react";
import {useLoansStore} from "../store/loans.store";
import {useLoans} from "../hook/partner/loans.partner.hook";
import {PartnerApi} from "../api/partner.api";
import {Pagination} from "../components/List/Pagination";
import {usePopper} from "react-popper";
import {useLoansTableStore} from "../store/loansTable.store";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import OpportunityNewModal from "../components/modals/opportunity/OpportunityNewModal";
import LoanNewModal from "../components/modals/loan/LoanNewModal";
import {NavLink} from "react-router";
import AnchorData from "../utils/AnchorData";
import {DealFilter} from "../components/Deal/DealFilter";
import {LoanFilter} from "../components/Loan/LoanFilter";
import {DealFilterActual} from "../components/Deal/DealFilterActual";
import {LoanFilterActual} from "../components/Loan/LoanFilterActual";
import { FulltextFilter } from "../components/List/FulltextFilter";
import DealRow from "../components/Deal/DealRow";
import LoanRow from "../components/Loan/LoanRow";
import DealTable from "../components/Deal/DealTable";
import LoanTable from "../components/Loan/LoanTable";
import {RowSelector} from "../components/List/RowSelector";
import { useTranslation } from "../hooks/useTranslation";

function Loans() {
    const loansMutation = useLoans();
    const { t } = useTranslation();
    const [page, setPage] = useState(1);

    const loan_filter = JSON.parse(localStorage.getItem("loan_filter"));

    const anchorData = AnchorData();
    const current_state_id = [];
    anchorData?.pageAllow === true && current_state_id.push("1");
    anchorData?.pageDisallow === true && current_state_id.push("-1");

    const [filter, setFilter] = useState(
        anchorData
            ? {
                current_state_id: current_state_id,
            }
            : {
                ...loan_filter,
                current_state_id: loan_filter?.current_state_id || current_state_id,
            }
    );

    const [showModalNew, setShowModalNew] = useState(false);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(() => {
        setPagename(t("loans.title"));
        setBreadcrumbs([]);
    }, []);

    const [rowsSelected, setRows] = useState(10);

    const [sortTable, setSortTable] = useState({
        sort: "loan_id",
        sortDirection: "desc",
    });

    const token = useAuthStore((state) => state.token);
    const loans = useLoansStore((state) => state.loans);

    useEffect(() => {
        if (token) {
            loansMutation.mutate({
                token,
                page,
                data: {
                    filter,
                    rows_per_page: rowsSelected,
                    sort: sortTable.sort,
                    sort_direction: sortTable.sortDirection
                },
                rowsSelected,
            });
            localStorage.setItem("loan_filter", JSON.stringify(filter));
        }
    }, [token, page, filter, rowsSelected, sortTable]);

    /* Dynamická tabulka */

    const selectedColumns = useLoansTableStore((state) => state.selectedColumns);
    const toggleColumn = useLoansTableStore((state) => state.toggleColumn);
    const getAvailableColumns = useLoansTableStore((state) => state.getAvailableColumns);
    const awailableColumns = getAvailableColumns();

    return (
        <>
            <div className="card mt-6">
                <div className="card-header border-0 pt-6">
                    <div className="card-title">

                        <div className="d-flex gap-2 align-items-center mb-2">
                        <FulltextFilter
                            onChange={(e) =>
                                setFilter({
                                    ...filter,
                                    fulltext: e.target.value,
                                })
                            }
                            placeholder={t("loans.searchLoan")}
                        />
                        <button
                            className="btn btn-success"
                            onClick={() =>
                                PartnerApi.loansExport({
                                    token,
                                    data: {
                                        filter: filter,
                                        sort: sortTable.sort,
                                        sort_direction: sortTable.sortDirection
                                    },
                                })
                            }
                        >
                            {t("common.exportXlsx")}
                        </button>
                    </div>
                    </div>

                    <div className="card-toolbar">
                        <div
                            className="d-flex justify-content-end"
                            data-kt-customer-table-toolbar="base"
                        >
                            <LoanNewModal
                                show={showModalNew}
                                handleClose={() => setShowModalNew(false)}
                            />

                            <LoanFilter
                                awailableColumns={awailableColumns}
                                selectedColumns={selectedColumns}
                                toggleColumn={toggleColumn}
                                setFilter={setFilter}
                                filter={filter}
                                setShowModalNew={setShowModalNew}
                            />
                        </div>
                    </div>
                </div>

                <div className="card-body pt-0">
                    <div className="border-top border-bottom py-3">
                        {t("common.totalCount")}: {loans?.rows}
                    </div>
                    <LoanFilterActual setFilter={setFilter} filter={filter}/>

                    <LoanTable
                        loans={loans}
                        awailableColumns={awailableColumns}
                        selectedColumns={selectedColumns}
                        sortTable={sortTable}
                        setSortTable={setSortTable}
                    />
                </div>
            </div>

      {loans?.rows > 0 && (
          <>
              <Pagination
                  total_pages={loans.total_pages}
                  rows_per_page={loans.rows_per_page}
                  page={page}
                  setPage={setPage}
              />
              <RowSelector setRows={setRows}/>
          </>
      )}
        </>
    );
}

export default Loans;
